import { Avatar, FormLabel } from "@material-ui/core";
import React from "react";
import EqualizerOutlinedIcon from "@material-ui/icons/EqualizerOutlined";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

export const NoQuestionPlaceholder = ({ pollTemplate }) => {
  const { placeholder } = pollTemplate;
  const {
    iconColor,
    iconBackgroundColor,
    fontWeight,
    fontFamily,
    color,
  } = placeholder;
  
  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <div className="centered-text">
        <Avatar
          style={{
            margin: "10px auto",
            width: 70,
            height: 70,
            background: iconBackgroundColor,
            color: iconColor,
          }}
        >
          <EqualizerOutlinedIcon style={{ fontSize: 38 }} />
        </Avatar>
        <FormLabel component="legend" style={{ color, fontWeight, fontFamily }}>
          <EventLabel2 name="NoQuestion" groupName="DigitalMeeting.Client" />
        </FormLabel>
      </div>
    </div>
  );
};
